import Chevron from '../../../public/assets/icons/chevron-right.svg';
import Button, { PrimaryButtonProps } from '@/components/common/Button';

type RMButton = Omit<PrimaryButtonProps, 'children'> & { text?: string };

const defaultText = 'Read More';

export const ReadMoreButton = ({ text = defaultText, ...rest }: RMButton) => (
  <Button {...rest}>
    {text}
    {text === defaultText && <span className="sr-only"> About this Topic</span>}
    <span className="pl-1">
      <Chevron />
    </span>
  </Button>
);
